import { ActionBuilder, NamespaceBuilder } from '@hub3js/core';
import { utils as solanaUtils } from '@hub3js/solana';
import * as commonBuilders from '@hub3js/std/builders';
import { privyAdapter } from '../../adapter';
import { SOCIAL_WALLET_TYPE } from '../constants';
export function buildSolanaNamespace() {
    const solanaNamespace = new NamespaceBuilder('Solana', SOCIAL_WALLET_TYPE);
    solanaNamespace.action(new ActionBuilder('connect')
        .action(async (_context) => {
        const privyContext = privyAdapter.getPrivyContext();
        const instance = privyContext.privySolanaWallets[0];
        if (!privyContext.ready) {
            throw new Error('Privy is not ready');
        }
        if (!instance) {
            throw new Error('Privy instance is not available!');
        }
        if (!privyContext.user) {
            throw new Error('User is not logged in!');
        }
        const solanaResult = instance.address;
        const formattedAccounts = solanaUtils.formatAccountsToCAIP([solanaResult]);
        if (formattedAccounts.length === 0) {
            throw new Error('No accounts found');
        }
        return formattedAccounts;
    })
        .and((context, accounts) => {
        const [, setState] = context.state();
        setState('accounts', accounts);
        setState('connected', true);
    })
        .or(() => {
        const privyContext = privyAdapter.getPrivyContext();
        privyContext.login();
    })
        .build());
    solanaNamespace.action(commonBuilders
        .disconnect()
        .and(() => {
        const privyContext = privyAdapter.getPrivyContext();
        if (!!privyContext.user) {
            void privyContext.logout();
        }
    })
        .build());
    return solanaNamespace.build();
}
